module.exports = ".chart-table {\n    border: 0px;\n    display: table;\n    width: 100%;\n    height: 400px;\n    table-layout: fixed;\n}\n\n.chart-cell {\n    display: table-cell;\n    vertical-align: top;\n    width:100%;\n    height: 400px;\n}\n\n.clearfix {\n    clear: both;\n}\n\ncanvas {\n    width: 100% !important;\n    height: 400px !important;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/chart/chart.component.css
// module id = ./src/app/shared/components/chart/chart.component.css
// module chunks = main